<template>
  <q-dialog v-model="downloadScheme" class="share-grant-main">
    <q-card class="share-dialog">
      <q-card-section>
        <div class="text-h5">Item downloaden</div>
      </q-card-section>
      <q-card-section>
        <div class="share-text">
          <div class="row">
            <q-icon name="share" style="font-size: 1.4em" />

            <div class="column">
              <span class="share-info bold">
                Te downloaden item:
              </span>

              <span class="share-info">
                {{ grant.name }}
              </span>
            </div>
          </div>
        </div>
      </q-card-section>
      <q-card-section>
        <div class="share-text-sm">
          <span class="share-info">
            Ontvanger
          </span>
          <q-input
            class="q-mt-sm"
            outlined
            v-model="address"
            dense
            type="email"
            :rules="[isValidEmail, requiredFieldRule]"
            label="Voeg een naam of e-mailadres toe"
          />
        </div>
      </q-card-section>

      <q-card-section>
        <div class="share-text-sm">
          <span class="share-info">
            Bericht *
          </span>
          <q-input
            :rules="requiredFieldRule"
            class="q-mt-sm"
            v-model="message"
            outlined
            type="textarea"
          />
        </div>
      </q-card-section>

      <q-card-actions class="q-mt-sm" align="left">
        <q-btn
          flat
          label="Delen"
          class="submit-btn"
          color="white"
          no-caps
          @click="shareSchemeEmit(address, message, grant.id)"
        />
        <q-btn
          flat
          label="Annuleren"
          no-caps
          class="cancel-btn"
          v-close-popup
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { computed, ref } from 'vue';
import store from '../../store/index';
import MailingService from '../../services/mailing.service';

export default {
  setup() {
    const downloadScheme = computed({
      get: () => store.state.grantItems.downloadScheme,
      set: (val) => store.commit('grantItems/disableDownloadScheme', val),
    });

    const grant = computed({
      get: () => store.state.grantItems.grantToShare,
    });

    const shareSchemeEmit = async (address, message, id) => {
      await MailingService.shareScheme(address, message, id);
    };

    const address = ref('');
    const message = ref('');
    return {
      message,
      address,
      shareSchemeEmit,
      downloadScheme,
      grant,

      requiredFieldRule: [
        (val) => (val && val.length > 0) || 'Veld is verplicht!',
      ],
      isValidEmail(val) {
        const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        return emailPattern.test(val) || 'Ongeldig e-mailadres';
      },
    };
  },
};
</script>
